export const ToastClass = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
}